module.exports = __webpack_public_path__ + "static/media/ehealth-bg3-mobile.9520af35.jpg";